// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3gtod","dragIcon":"SortableItem_dragIcon__1WXcj","disabled":"SortableItem_disabled__2EMNk"};